import React, { useContext, useEffect } from "react";
import Hero from "./components/Hero";
// import style from '../styles/style.css';
import Marketing1 from "../../shared/components/Marketing1";
import MarketingWorkshops from "./components/MarketingWorkshops";
import { useDispatch, useSelector } from "react-redux";
import { initDraft } from "../../app/store/reservationSlice"; // <-- Import initDraft
import WorkshopNewsSection from "./components/WorkshopNewsSection";
import filterContext from "../../app/providers/filter/filterContext";
import { Box } from "@mui/material";
// import { useWindowSize } from "../hooks/useWindowSize";

export default function Homepage() {

    const dispatch = useDispatch();
    const draft = useSelector((state) => state.reservation.draft);
    const { clearFilter } = useContext(filterContext);
    // const { isDesktop } = useWindowSize();

    useEffect(() => {
        dispatch(initDraft()); // <-- Use the slice's initDraft action
    }, [dispatch]);

    useEffect(() => {
        window.scrollTo(0, 0);
        clearFilter();
    }, []);

    return (
        <Box className="homepage">
            <Hero />
            <Marketing1 />
            <WorkshopNewsSection />
            <MarketingWorkshops />
        </Box>
    )
}